const captionSide = {
  name: "caption-side",
  path: "/caption-side",
  title: "caption-side",
  description: "Utilities for controlling the position of table captions.",
  value: {
    'caption-side': {
      'caption-top': 'top',
      'caption-bottom': 'bottom',
    },
  },
  exampleData: [
    {
      example: {
        code: `<table class="w-full">
  <caption class="caption-top mb-2 text-color-gray-700 dark:text-color-gray-200">Top Caption</caption>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">A</td>
    <td class="border border-color-gray-300 px-4 py-2">B</td>
  </tr>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">C</td>
    <td class="border border-color-gray-300 px-4 py-2">D</td>
  </tr>
</table>
<table class="w-full mt-6">
  <caption class="caption-bottom mt-2 text-color-gray-700 dark:text-color-gray-200">Bottom Caption</caption>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">A</td>
    <td class="border border-color-gray-300 px-4 py-2">B</td>
  </tr>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">C</td>
    <td class="border border-color-gray-300 px-4 py-2">D</td>
  </tr>
</table>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">caption-top</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">caption-bottom</code> to control the position of table captions.
      </p>
      <div class="flex flex-col">
        <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">caption-top</p>
        <table class="w-full">
          <caption class="caption-top mb-2 text-color-gray-700 dark:text-color-gray-200">Top Caption</caption>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">A</td>
            <td class="border border-color-gray-300 px-4 py-2">B</td>
          </tr>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">C</td>
            <td class="border border-color-gray-300 px-4 py-2">D</td>
          </tr>
        </table>
        <p class="mb-2 mt-8 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">caption-bottom</p>
        <table class="w-full">
          <caption class="caption-bottom mt-2 text-color-gray-700 dark:text-color-gray-200">Bottom Caption</caption>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">A</td>
            <td class="border border-color-gray-300 px-4 py-2">B</td>
          </tr>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">C</td>
            <td class="border border-color-gray-300 px-4 py-2">D</td>
          </tr>
        </table>
      </div>
      `
    }
  ]
};

export default captionSide;
<div className="sr-only caption-top caption-bottom"></div>